import { useQuery } from 'react-query';

import ReportApi from 'api/report';
import Widget from './Widget';
// import RequireFilters from './RequireFilters';

const WidgetList = ({ reportId }) => {
  const { data } = useQuery(['report', reportId], () => ReportApi.get(reportId));

  const report = data;

  if (!report) {
    return null;
  }

  // const keys = Object.keys(filters);
  // const formFilters = keys.filter(key => key !== 'company' && key !== 'report');
  // if (!formFilters.length && report.filter_form) {
  //   return <RequireFilters />;
  // }

  const widgets = report.widgets || [];
  return widgets.map(widget => <Widget key={widget.id} {...widget} report={report} />);
};

export default WidgetList;
